import React from 'react'
import styled from 'styled-components'
import {
  WhatsappShareButton,
  FacebookShareButton,
  EmailShareButton,
  LinkedinShareButton,
} from 'react-share'

// Images
import Facebook from 'img/sharefacebook.inline.svg'
import LinkedIn from 'img/sharelinkedin.inline.svg'
import Mail from 'img/sharemail.inline.svg'
import WhatsApp from 'img/sharewhatsapp.inline.svg'

const ShareContainer = styled.div`
  & h2 {
    color: ${({ theme }) => theme.color.light};
    font-size: 20px;
  }

  & svg {
    width: 22px;
    height: 22px;
    opacity: 0.75;
    &:hover {
      opacity: 1;
    }
  }
`

interface ShareProps {
  heading: string
  location: any
  title: string
  body: string
  quote?: string
  className?: string
}

const Share: React.FC<ShareProps> = ({
  heading,
  location,
  title,
  body,
  quote,
  className = '',
}) => {
  const shareUrl = location ? location.href : ''

  const removeHTML = quote?.replace(/<\/?[^>]+(>|$)/g, '')
  const removeQuote = removeHTML?.replace('&#8220;', '"')
  const cleanQuote = removeQuote?.replace('&#8221;', '"')

  return (
    <ShareContainer className={className}>
      <h2 className="mb-0 me-4">{heading}</h2>
      <div>
        <FacebookShareButton
          url={shareUrl}
          quote={cleanQuote}
          title={title}
          className="me-3"
        >
          <div className="position-relative d-flex flex-column justify-content-center align-items-center">
            <div>
              <Facebook />
            </div>
          </div>
        </FacebookShareButton>
      </div>
      <div>
        <LinkedinShareButton
          url={shareUrl}
          title={title}
          summary={body}
          source={shareUrl}
          className="me-3"
        >
          <div className="position-relative d-flex flex-column justify-content-center align-items-center">
            <div>
              <LinkedIn />
            </div>
          </div>
        </LinkedinShareButton>
      </div>
      <div>
        <EmailShareButton
          url={shareUrl}
          subject={title}
          body={body}
          className="me-3"
        >
          <div className="position-relative d-flex flex-column justify-content-center align-items-center">
            <div>
              <Mail />
            </div>
          </div>
        </EmailShareButton>
      </div>
      <div>
        <WhatsappShareButton url={shareUrl} title={title} className="me-3">
          <div className="position-relative d-flex flex-column justify-content-center align-items-center">
            <div>
              <WhatsApp />
            </div>
          </div>
        </WhatsappShareButton>
      </div>
    </ShareContainer>
  )
}

export default Share
